$(function () {
  if (window.footer) {
    return;
  }

  const dropdownToggle = $('.dropdown-toggle');
  const dropdownMenu = $('.dropdown-menu');

  dropdownToggle.click(function(e) {
    e.stopPropagation();
    dropdownToggle.toggleClass('active');
    dropdownMenu.toggleClass('show');

    var dropdownHeight = dropdownMenu.outerHeight();
    var toggleOffset = dropdownToggle.offset();
    var viewportHeight = $(window).height();
    var scrollTop = $(window).scrollTop();

    var spaceBelow = viewportHeight - (toggleOffset.top - scrollTop + dropdownToggle.outerHeight());
    var spaceAbove = toggleOffset.top - scrollTop;

    if (dropdownHeight > spaceBelow && spaceAbove > spaceBelow) {

      dropdownMenu.css({
        top: 'auto',
        bottom: $(window).height() - toggleOffset.top + 'px',
        left: toggleOffset.left + 'px'
      });
    } else {
      // Position dropdown below the button
      dropdownMenu.css({
        top: toggleOffset.top + dropdownToggle.outerHeight() + 'px',
        bottom: 'auto',
        left: toggleOffset.left + 'px'
      });
    }
  });

  $('.newsletter-form [type="submit"]').click(function (e) {
    e.preventDefault();

    const form = $(this).parent().parent();
    const emailInput = form.find('input[type="email"]');
    const agreeCheckbox = form.find('input[type="checkbox"]');

    const errorMessageAlreadyPresent = form.find('.checkbox-error');
    if (errorMessageAlreadyPresent.length) {
      errorMessageAlreadyPresent.remove();
    }

    if (!agreeCheckbox.is(':checked')) {
      const translationError = window.i18next.t('validation.required', { attribute: 'agreement' })
      $(`<p class="error-message checkbox-error">${translationError}</p>`).insertAfter(agreeCheckbox.parent());
      return;
    }

    $.ajax({
      method: 'POST',
      url: window.newsletterValidateUrl,
      data: { email: emailInput.val(), },
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      success: function (response) {
        emailInput.parent().removeClass('border border-[#CF1900] rounded-lg');
        const errorMessageAlreadyPresent = form.find('.email-error');
        if (errorMessageAlreadyPresent.length) {
          errorMessageAlreadyPresent.remove();
        }

        if (!response?.success) {
          emailInput.parent()
            .addClass('border border-[#CF1900] rounded-lg');
          const translationError = window.i18next.t('validation.email', { attribute: 'email' })
          $(`<p class="error-message email-error">${translationError}</p>`).insertAfter(emailInput.parent());
          return;
        }

        $('.newsletter-form').submit();
      },
      error: function (response) {
        emailInput.parent()
          .addClass('border border-[#CF1900] rounded-lg');
        const translationError = window.i18next.t('validation.email', { attribute: 'email' })
        $(`<p class="error-message email-error">${translationError}</p>`).insertAfter(emailInput.parent());
      }
    });
  });

  window.footer = true;
});
